import { UIText2 } from '@cian/ui-kit';

import * as styles from './AsideRow.css';

interface IAsideRowProps {
  title: string;
  content: React.ReactNode;
}

export const AsideRow = ({ title, content }: IAsideRowProps) => {
  return (
    <div className={styles['field']}>
      <div className={styles['title']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['content']}>{content}</div>
    </div>
  );
};
